export default __webpack_public_path__ + "static/media/visualizacao-black.ee94fd3d.svg";